import { PageHeader, Hero } from '../components/PageComponents';
import './Support.css';

function Support() {
  return (
    <>
      <Hero 
        imageSrc="/Images/PI-ID384276.jpg"
        imageAlt="Customer Support"
        title="Support"
        subtitle="We're here to help you get the most from our software"
      />

      <div className="container">
        <section className="section">
          <div className="panel">
            <h3>Support Request</h3>
            <p>We are committed to helping you get the most value from our software products.</p>
            <p>Please provide a clear and concise description of your query or feedback. We will strive to provide a response within 3 business days.</p>
            <p>Complete all fields in the form below.</p>
          </div>

          <div className="iframe-container">
            <iframe
              title="SMART-WARES Support Form"
              allowTransparency
              frameBorder="0"
              width="100%"
              height="900px"
              src="https://feedback.smartwareshelpdesk.com/SW/apps/Feedback.aspx?Subject=swsitesupport"
            />
          </div>
        </section>
      </div>
    </>
  );
}

export default Support;
